import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Page } from "entities/pages/types";
import React, { FC } from "react";
import { COLOR_SECONDARY_ORANGE } from "shared/theme/colors";
import { WarningIcon } from "shared/theme/icons/WarningIcon";
import { usePagesPage } from "../../context";
import { StyledBox } from "./styled";

const MaintenanceModeWarningMessage: FC = () => {
  const { pageMaintenanceModeModal } = usePagesPage();

  const page = pageMaintenanceModeModal.modalDetails as Page;

  const getWarningMessage = () => {
    const messages = [];

    if (page?.isDefaultForAuthenticated) {
      messages.push("authorized");
    }

    if (page?.isDefaultForUnauthenticated) {
      messages.push("non-authorized");
    }

    if (messages.length > 0) {
      return `This page is set as default for ${messages.join(" and ")} users. To maintain uninterrupted access, we recommend assigning a new default page before disabling this one.`;
    }

    return "";
  };

  if (
    page &&
    (!page.isDefaultForAuthenticated || !page.isDefaultForUnauthenticated)
  ) {
    return null;
  }

  return (
    <StyledBox>
      <Box mt="2px">
        <WarningIcon />
      </Box>
      <Typography variant="bodyMMedium" color={COLOR_SECONDARY_ORANGE}>
        {getWarningMessage()}
      </Typography>
    </StyledBox>
  );
};

export default MaintenanceModeWarningMessage;
